<div>
  <ion-icon style="    position: fixed;  top: 7px;  width: 62px;
    height: 22px;" name="arrow-back" class="close-fab" [routerLink]="['/mainTabs/tabs/home']" routerDirection="back">
  </ion-icon>
  <dl>
    <div class="ion-text-center">
      <dt>
        <div class="signup-text">
          <h3 class="heading"> Events</h3>
        </div>
      </dt>
    </div>
  </dl>
</div>
<ion-content scrollEvents="true">
  <mat-accordion>
    @for (event of (testerEvent$ | async); track event) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{event.id}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p> Type: {{event?.celebration?.type}}</p>
        <p> comment_postid: {{event?.comment_postid}}</p>
        <p> xp_amount: {{event?.xp_amount}}</p>
        <p> xp_type: {{event?.xp_amount}}</p>
      </mat-expansion-panel>
    }
  </mat-accordion>
</ion-content>